import { useState } from "react";
import "./q-and-a.scss";

export default function QandA() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  const qaData = [
    {
      question: "When is the RSVP date?",
      answer:
        "Please RSVP for the ceremony and reception by March 11th so we can make sure everything is perfectly arranged! You can RSVP on the “RSVP” page of the website.",
    },
    {
      question: "What if I don’t RSVP in time?",
      answer:
        "If we don’t receive an RSVP by March 11th, it will automatically be counted as a “No. Your presence will be missed, however it is imperative for us and our vendors to have a final guest count within a certain time frame. Thank you for understanding.",
    },
    {
      question: "What time should I arrive?",
      answer: (
        <>
          Please take a look at the{" "}
          <a className="cormorant-600 underline" href="/details">
            Details
          </a>{" "}
          page on our website for detailed information about our ceremony and
          reception venues and itinerary.
        </>
      ),
    },
    {
      question: "Where should I park?",
      answer:
        "There is plenty of free parking available at both the Basilica of Our Lady Immaculate and Roseville Estate. If you wish to leave your car overnight at Roseville Estate, you may park until 11am the following day.",
    },
    {
      question: "Should I attend the ceremony?",
      answer:
        "Yes! The ceremony is the heart of our wedding, where we enter into the sacrament of Holy Matrimony before God. Your presence and prayers mean so much as we begin our vocation of marriage in Christ!",
    },
    {
      question: "Am I allowed to take photos and videos at your wedding?",
      answer:
        "Yes! We’d love for you to capture moments from your POV and share them with us. However, out of respect and reverence for our Holy Church during the ceremony, we kindly ask everyone to keep their phones and cameras away so you can be fully present with us. Our photographers and videographers will capture all the beautiful moments, and we’d love to share those memories with you afterward!",
    },
    {
      question: "Can I bring a guest?",
      answer:
        "Due to venue capacity, we’re only able to accommodate guests listed on the invitation. We truly appreciate your understanding.",
    },
    {
      question: "Are kids invited?",
      answer:
        "While we love your little ones, unfortunately due to venue capacity we are unable to accommodate everyone. Please check the names listed on your invitation.",
    },
    {
      question: "What should I wear?",
      answer: (
        <>
          Please see the{" "}
          <a className="cormorant-600 underline" href="/details">
            Details
          </a>{" "}
          section of the website and scroll down to “attire” for information on
          how to dress for the day.
        </>
      ),
    },
    {
      question: "Is there an open bar?",
      answer:
        "Yes! Drinks will be flowing all night, including a selection of beer, wine, and cocktails. The drinks are on us, but the hangover is on you! Please drink responsibly. If you need to leave your car overnight, there is free parking at Roseville Estate until 11am the next day.",
    },
    {
      question: "Who do I contact if I have more questions?",
      answer: (
        <>
          If you need any more details, feel free to reach out to us at{" "}
          <a
            className="cormorant-600 underline"
            href="mailto:theralloswedding@gmail.com"
          >
            theralloswedding@gmail.com
          </a>{" "}
          or text us! (You can find our numbers below on every page of the
          website lol)
        </>
      ),
    },
  ];

  return (
    <div className="qa fade-in">
      <div className="qa-container display-flex flex-column justify-center align-center padding-bottom-50">
        <h1 className="qa-title padding-10 text-center cormorant-light-400 letter-spacing-5 text-medium ">
          QUESTIONS & ANSWERS
        </h1>
        <div className="qa-item-container">
          {qaData.map((item, index) => (
            <div
              key={index}
              className={`qa-item ${openIndex === index ? "open" : ""}`}
            >
              <button
                className="qa-question cormorant-italic-500"
                onClick={() => toggle(index)}
                aria-expanded={openIndex === index}
              >
                {item.question}
                <span className="qa-icon">
                  {openIndex === index ? "−" : "+"}
                </span>
              </button>

              <div className="qa-answer">
                <p className="cormorant-light-300 font-size-4 text-center">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="qa-bg"></div>
    </div>
  );
}
